import {
    all,
    SagaIterator,
    takeEveryCompletedRequest
} from './core/sagaEffects';
import { CancelFlightRequestRequest, CreateFlightRequestRequest, EditFlightRequestRequest } from 'acscp/api/requests';
import history from 'acscp/store/history';
import { chartersList } from 'acscp/components/routeHelper';

export function* flightRequestSaga(): SagaIterator {
    yield all([
        takeEveryCompletedRequest(CreateFlightRequestRequest, redirectToFlightRequestSubmittedPage),
        takeEveryCompletedRequest(EditFlightRequestRequest, redirectToFlightRequestSubmittedPage),
        takeEveryCompletedRequest(CancelFlightRequestRequest, redirectToTripPage)
    ]);
}

function* redirectToFlightRequestSubmittedPage(): SagaIterator {
    history.push('/flight-requests/thank-you');
}

function* redirectToTripPage(reponse: undefined): SagaIterator {
    history.push(chartersList());
}
